import { Paper, SxProps } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { IAcxHierarchyComponentProps } from "./AcxHierarchySelector";
import HierarchySelectorFooter from "./HierarchySelectorFooter";
import HierarchySelectorHeader from "./HierarchySelectorHeader";
import HierarchySelectorTree from "./HierarchySelectorTree";

const HierarchySelectorBase: React.FC<IAcxHierarchyComponentProps> = observer(
    (props: IAcxHierarchyComponentProps) => {
        return (
            <Paper
                sx={(theme) => {
                    const maxSelectorHeight =
                        "min(703px, calc(100vh - 96px))";
                    const gridTemplateRows = props.hideTopContent
                        ? props.hideBottomContent || props.viewOnly
                            ? "minmax(0, 1fr)"
                            : "minmax(0, 1fr) auto"
                        : props.hideBottomContent || props.viewOnly
                          ? "auto minmax(0, 1fr)"
                          : "auto minmax(0, 1fr) auto";
                    const paperStyles: SxProps = {
                        margin: "0.25rem 0.5rem 0.5rem",
                        width: "350px",
                        backgroundColor: "#ffffff",
                        borderRadius: "8px",
                        boxShadow: "none",
                        display: "grid",
                        gridTemplateRows,
                        overflow: "hidden",
                        maxHeight: maxSelectorHeight,
                    };
                    if (props?.fixedPopper) {
                        paperStyles.position = "relative";
                        paperStyles.left = "393px";
                        paperStyles.top = "5px";
                    }
                    if (props.popperWidth) {
                        paperStyles.width = props.popperWidth;
                    } else {
                        paperStyles.width = props.width;
                    }
                    props.fullHeight
                        ? (paperStyles.height = maxSelectorHeight)
                        : (paperStyles.maxHeight = maxSelectorHeight);
                    return paperStyles;
                }}
            >
                {!props.hideTopContent && (
                    <HierarchySelectorHeader {...props} />
                )}

                <HierarchySelectorTree {...props} />

                {!props.hideBottomContent && !props.viewOnly && (
                    <HierarchySelectorFooter {...props} />
                )}
            </Paper>
        );
    },
);

export default HierarchySelectorBase;
